// Whether a patch changes any of ``keys``, by value: an equal but new filters
// array is no change. Shared by the grid's and the Tables tab's views, so a
// page reset and a kept selection agree on what "changed" means.
export function changesAny<T extends object>(
  prev: T,
  patch: Partial<T>,
  keys: (keyof T)[]
): boolean {
  return keys.some(
    (key) =>
      key in patch && JSON.stringify(patch[key]) !== JSON.stringify(prev[key])
  );
}
